import { clsx } from 'clsx'
import * as React from 'react'

import { Input, SearchIcon } from '@buffer-mono/popcorn'
import type { InputProps } from '@buffer-mono/popcorn'

import styles from './FilterInput.module.css'

import type { JSX } from 'react'

type FilterInputProps = Omit<
  InputProps,
  'prefix' | 'type' | 'value' | 'onChange'
> & {
  /** Current filter text (controlled). */
  value: string
  /** Called with the new filter text on each keystroke. */
  onValueChange: (value: string) => void
}

/**
 * A controlled search input for filtering a list in place, with a leading
 * search icon. Used above channel and team-member lists in dialogs to narrow
 * what's shown without changing the underlying selection or data.
 *
 * Filtering itself lives with the caller — this is just the input.
 */
export const FilterInput = React.forwardRef<HTMLInputElement, FilterInputProps>(
  (
    { value, onValueChange, className, ...props },
    forwardedRef,
  ): JSX.Element => {
    return (
      <Input
        {...props}
        type="search"
        prefix={<SearchIcon />}
        value={value}
        onChange={(e): void => onValueChange(e.target.value)}
        ref={forwardedRef}
        className={clsx(styles.filterInput, className)}
      />
    )
  },
)

FilterInput.displayName = 'FilterInput'

export type { FilterInputProps }
